import { render, staticRenderFns } from "./OnlineUsers.vue?vue&type=template&id=00488c14&"
import script from "./OnlineUsers.vue?vue&type=script&lang=js&"
export * from "./OnlineUsers.vue?vue&type=script&lang=js&"
import style0 from "./OnlineUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports